class ClearDisplayCaseRegion extends HTMLElement {
  connectedCallback() {
    const selector = this.querySelector('[data-case-region]');
    const controls = this.querySelector('[data-case-buy-controls]');
    const notice = this.querySelector('[data-case-region-notice]');
    if (!selector || !controls || !notice) return;
    const update = () => {
      const allowed = selector.value === 'GB';
      controls.disabled = !allowed;
      controls.hidden = !allowed;
      notice.hidden = selector.value !== 'NI';
    };
    selector.addEventListener('change', update);
    this.closest('form')?.addEventListener('submit', (event) => {
      if (selector.value !== 'GB') {
        event.preventDefault();
        event.stopImmediatePropagation();
        selector.focus();
      }
    }, { capture: true });
    update();
  }
}
if (!customElements.get('clear-display-case-region')) {
  customElements.define('clear-display-case-region', ClearDisplayCaseRegion);
}

